(function () {
  'use strict';

  // Wrap only plain link labels; repeated section mounts never nest wrappers.
  function initLinkLabels(root) {
    var selector = '.desktop-nav > a, .mega-wrap > a, .mega-menu a, .mobile-menu nav a, .footer__column a, .footer__bottom a, a.text-link, .ainaz-banner-copy a.button--light';
    root.querySelectorAll(selector).forEach(function (link) {
      Array.from(link.childNodes).forEach(function (node) {
        if (node.nodeType !== 3 || !node.textContent.trim()) return;
        var label = document.createElement('span');
        label.className = 'link-label';
        label.textContent = node.textContent.trim().replace(/\s+/g, ' ');
        node.replaceWith(label);
      });
      if (link.querySelector('.link-label')) link.classList.add('ainaz-ink-link');
    });
  }

  /* ─────────────────────────────────────────────
   * 1. Announcement rotator
   * Container: [data-announcement-bar]
   * Children:  [data-announcement-item]
   * ───────────────────────────────────────────── */
  function initAnnouncementBar(root) {
    root.querySelectorAll('[data-announcement-bar]').forEach(function (bar) {
      if (bar.dataset.init) return;
      bar.dataset.init = '1';

      var items = Array.from(bar.querySelectorAll('[data-announcement-item]'));
      if (!items.length) return;
      var current = 0, paused = false, hovering = false, focused = false;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var live = bar.querySelector('[aria-live]');
      var prev = bar.querySelector('[data-announcement-prev]');
      var next = bar.querySelector('[data-announcement-next]');
      var pause = bar.querySelector('[data-announcement-pause]');
      function show(index) {
        current = (index + items.length) % items.length;
        items.forEach(function(item, i) { item.hidden = i !== current; item.classList.toggle('is-active', i === current); });
      }
      function stop() { clearInterval(bar._rotTimer); bar._rotTimer = null; if(live) live.setAttribute('aria-live', 'polite'); }
      function start() {
        stop();
        if (items.length < 2 || bar.dataset.autoplay !== 'true' || paused || hovering || focused || reduce.matches || document.hidden) return;
        if(live) live.setAttribute('aria-live', 'off');
        bar._rotTimer = setInterval(function() { show(current + 1); }, 6000);
      }
      function manual(delta) { paused = true; stop(); if(pause) { pause.textContent = 'Play'; pause.setAttribute('aria-pressed', 'true'); } show(current + delta); }
      function onPrev() { manual(-1); }
      function onNext() { manual(1); }
      function onPause() { paused = !paused; pause.textContent = paused ? 'Play' : 'Pause'; pause.setAttribute('aria-pressed', String(paused)); start(); }
      function enter() { hovering = true; stop(); }
      function leave() { hovering = false; start(); }
      function focusIn() { focused = true; stop(); }
      function focusOut(event) { if(!bar.contains(event.relatedTarget)) { focused = false; start(); } }
      if(prev) prev.addEventListener('click', onPrev);
      if(next) next.addEventListener('click', onNext);
      if(pause) pause.addEventListener('click', onPause);
      bar.addEventListener('mouseenter', enter); bar.addEventListener('mouseleave', leave);
      bar.addEventListener('focusin', focusIn); bar.addEventListener('focusout', focusOut);
      document.addEventListener('visibilitychange', start);
      if(reduce.addEventListener) reduce.addEventListener('change', start);
      bar._disposeAnnouncement = function() {
        stop(); delete bar.dataset.init;
        if(prev) prev.removeEventListener('click', onPrev);
        if(next) next.removeEventListener('click', onNext);
        if(pause) pause.removeEventListener('click', onPause);
        bar.removeEventListener('mouseenter', enter); bar.removeEventListener('mouseleave', leave);
        bar.removeEventListener('focusin', focusIn); bar.removeEventListener('focusout', focusOut);
        document.removeEventListener('visibilitychange', start);
        if(reduce.removeEventListener) reduce.removeEventListener('change', start);
      };
      show(0); start();
    });
  }

  /* ─────────────────────────────────────────────
   * 2. Header compaction
   * Element: [data-brand-header]
   * Adds/removes class `site-header--compact` at scrollY > 36
   * (class matches the ported prototype stylesheet, theme.css:114)
   * ───────────────────────────────────────────── */
  var headerScrollBound = false;

  function initHeaderCompaction(root) {
    // Header is typically in <body>, not inside a section root — use document
    if (document.querySelectorAll('[data-brand-header]').length === 0) return;

    // Guard: only attach scroll listener once
    if (headerScrollBound) return;
    headerScrollBound = true;

    function onScroll() {
      var compact = window.scrollY > 36;
      // Re-query at event time so headers re-injected by the editor are found
      document.querySelectorAll('[data-brand-header]').forEach(function (h) {
        h.classList.toggle('site-header--compact', compact);
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // initial check
  }

  /* ─────────────────────────────────────────────
   * 3. Mobile menu
   * [data-menu-open]    — open button
   * [data-mobile-menu]  — menu panel
   * [data-menu-close]   — close button (inside panel)
   * [data-menu-backdrop]— backdrop element
   * ───────────────────────────────────────────── */
  function initMobileMenu(root) {
    root.querySelectorAll('[data-menu-open]').forEach(function (openBtn) {
      if (openBtn._disposeMenu) return;
      var menu=document.querySelector('[data-mobile-menu]');
      if(!menu)return;
      var panel=menu.querySelector('.parity-mobile-menu-inner');
      var backdrop=menu.querySelector('[data-menu-backdrop]');
      var closers=Array.from(menu.querySelectorAll('[data-menu-close]'));
      var desktop=window.matchMedia('(min-width:1024px)');
      function finishClose(){if(window.AinazOverlay)window.AinazOverlay.close(menu);else{document.body.style.overflow='';openBtn.focus();}}
      function closeMenu(options){
        openBtn.setAttribute('aria-expanded','false');
        if(window.AinazDrawerMotion)window.AinazDrawerMotion.close({root:menu,panel:panel,backdrop:backdrop,side:'left',immediate:!!(options&&options.immediate),onClosed:finishClose});
        else{menu.classList.remove('is-open');finishClose();}
      }
      function openMenu(){
        if(window.AinazDrawerMotion)window.AinazDrawerMotion.open({root:menu,panel:panel,backdrop:backdrop,side:'left'});
        else menu.classList.add('is-open');
        openBtn.setAttribute('aria-expanded','true');
        if(window.AinazOverlay)window.AinazOverlay.open(menu,closeMenu,openBtn);
      }
      function resized(){if(desktop.matches&&menu.classList.contains('is-open'))closeMenu({immediate:true});}
      openBtn.addEventListener('click',openMenu);
      closers.forEach(function(button){button.addEventListener('click',closeMenu);});
      if(backdrop)backdrop.addEventListener('click',closeMenu);
      if(desktop.addEventListener)desktop.addEventListener('change',resized);
      openBtn._disposeMenu=function(){
        closeMenu({immediate:true});openBtn.removeEventListener('click',openMenu);
        closers.forEach(function(button){button.removeEventListener('click',closeMenu);});
        if(backdrop)backdrop.removeEventListener('click',closeMenu);
        if(desktop.removeEventListener)desktop.removeEventListener('change',resized);
        delete openBtn._disposeMenu;
      };
    });
  }

  /* ─────────────────────────────────────────────
   * 4. Single-open FAQ
   * Container: [data-faq]
   * Items:     [data-faq-item] each with:
   *   [data-faq-toggle]  — trigger button
   *   [data-faq-panel]   — answer panel
   * ───────────────────────────────────────────── */
  function initFaq() { /* FAQ lifecycle is owned by ainaz-discovery.js. */ }

  /* ─────────────────────────────────────────────
   * 5. Hero carousel
   * Container: [data-hero-carousel]
   * Slides:    [data-carousel-slide]
   * Dots:      [data-carousel-dots] (optional, generated)
   * ───────────────────────────────────────────── */
  function initHeroCarousel(root) {
    root.querySelectorAll('[data-hero-carousel]').forEach(function(carousel) {
      if(carousel._disposeCarousel) return;
      var slides=Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
      if(slides.length<2) return;
      var dots=carousel.querySelector('[data-carousel-dots]'),prev=carousel.querySelector('[data-carousel-prev]'),next=carousel.querySelector('[data-carousel-next]'),pause=carousel.querySelector('[data-carousel-pause]');
      var current=0,paused=false,hovering=false,focused=false,reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
      if(dots){dots.replaceChildren();slides.forEach(function(_,index){var dot=document.createElement('button');dot.type='button';dot.dataset.carouselDot=String(index);dot.setAttribute('aria-label','Go to slide '+(index+1));dot.appendChild(document.createElement('span'));dots.appendChild(dot);});}
      function show(index){current=(index+slides.length)%slides.length;slides.forEach(function(slide,i){slide.hidden=i!==current;slide.classList.toggle('is-active',i===current);slide.setAttribute('aria-hidden',String(i!==current));if(i!==current)slide.querySelectorAll('video').forEach(function(video){video.pause();});});if(dots)Array.from(dots.children).forEach(function(dot,i){dot.classList.toggle('is-active',i===current);dot.setAttribute('aria-current',i===current?'true':'false');});}
      function stop(){clearInterval(carousel._autoTimer);carousel._autoTimer=null;}
      function start(){stop();if(carousel.dataset.autoplay==='true'&&!paused&&!hovering&&!focused&&!reduce.matches&&!document.hidden)carousel._autoTimer=setInterval(function(){show(current+1);},6500);}
      function manual(index){paused=true;stop();if(pause){pause.setAttribute('aria-label','Play banners');pause.setAttribute('aria-pressed','true');}show(index);}
      function previous(){manual(current-1);}function following(){manual(current+1);}function keys(event){if(/INPUT|TEXTAREA|SELECT/.test(event.target.tagName))return;if(event.key==='ArrowRight'){event.preventDefault();following();}if(event.key==='ArrowLeft'){event.preventDefault();previous();}}
      function dotClick(event){var dot=event.target.closest('[data-carousel-dot]');if(dot)manual(Number(dot.dataset.carouselDot));}
      function toggle(){paused=!paused;pause.setAttribute('aria-label',paused?'Play banners':'Pause banners');pause.setAttribute('aria-pressed',String(paused));start();}
      function enter(){hovering=true;stop();}function leave(){hovering=false;start();}function focusIn(){focused=true;stop();}function focusOut(event){if(!carousel.contains(event.relatedTarget)){focused=false;start();}}
      if(prev)prev.addEventListener('click',previous);if(next)next.addEventListener('click',following);if(dots)dots.addEventListener('click',dotClick);if(pause)pause.addEventListener('click',toggle);
      carousel.addEventListener('keydown',keys);carousel.addEventListener('mouseenter',enter);carousel.addEventListener('mouseleave',leave);carousel.addEventListener('focusin',focusIn);carousel.addEventListener('focusout',focusOut);document.addEventListener('visibilitychange',start);if(reduce.addEventListener)reduce.addEventListener('change',start);
      carousel._disposeCarousel=function(){stop();if(prev)prev.removeEventListener('click',previous);if(next)next.removeEventListener('click',following);if(dots){dots.removeEventListener('click',dotClick);dots.replaceChildren();}if(pause)pause.removeEventListener('click',toggle);carousel.removeEventListener('keydown',keys);carousel.removeEventListener('mouseenter',enter);carousel.removeEventListener('mouseleave',leave);carousel.removeEventListener('focusin',focusIn);carousel.removeEventListener('focusout',focusOut);document.removeEventListener('visibilitychange',start);if(reduce.removeEventListener)reduce.removeEventListener('change',start);delete carousel._disposeCarousel;};show(0);start();
    });
  }

  /* ─────────────────────────────────────────────
   * 6. Quantity steppers
   * [data-qty-minus] / [data-qty-plus] adjust sibling input[data-qty-input]
   * ───────────────────────────────────────────── */
  function initQtySteppers(root) {
    root.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(function (btn) {
      if (btn.dataset.init) return;
      btn.dataset.init = '1';

      btn.addEventListener('click', function () {
        var parent = btn.closest('[data-qty-wrapper]') || btn.parentElement;
        var input = parent && parent.querySelector('input[data-qty-input]');
        if (!input) return;

        var val = parseInt(input.value, 10) || 1;
        var minAttr = parseInt(input.min, 10);
        var min = isNaN(minAttr) ? 1 : Math.max(1, minAttr);
        var delta = btn.hasAttribute('data-qty-plus') ? 1 : -1;
        input.value = Math.max(min, val + delta);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ─────────────────────────────────────────────
   * 7. Email form validation
   * Forms: [data-validate-email]
   * Error element: [data-form-error]
   * ───────────────────────────────────────────── */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function initEmailValidation(root) {
    root.querySelectorAll('[data-validate-email]').forEach(function (form) {
      if (form.dataset.init) return;
      form.dataset.init = '1';

      form.addEventListener('submit', function (e) {
        var emailInput = form.querySelector('input[type="email"]');
        var errorEl = form.querySelector('[data-form-error]');
        if (!emailInput) return;

        if (!EMAIL_RE.test(emailInput.value.trim())) {
          e.preventDefault();
          if (errorEl) errorEl.hidden = false;
        } else {
          if (errorEl) errorEl.hidden = true;
          // Valid: let Shopify handle the POST natively
        }
      });
    });
  }

  /* ─────────────────────────────────────────────
   * 8. Wishlist
   * Buttons: [data-wishlist-toggle="product-handle"]
   * Storage: localStorage key 'ainaz:wishlist'
   * Count:   [data-wishlist-count]
   * ───────────────────────────────────────────── */
  var WISHLIST_KEY = 'ainaz:wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(WISHLIST_KEY);
      var list=raw ? JSON.parse(raw) : []; return Array.isArray(list) ? list.filter(function(handle){return typeof handle === 'string' && /^[a-z0-9-]+$/.test(handle);}) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) { /* storage unavailable */ }
  }

  function updateWishlistCount(count) {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function initWishlist(root) {
    // If wishlist is globally disabled, hide all buttons and bail
    if (document.body.dataset.wishlistEnabled === 'false') {
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        btn.hidden = true;
      });
      return;
    }

    var wishlist = getWishlist();
    updateWishlistCount(wishlist.length);

    root.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      if (btn.dataset.init) return;
      btn.dataset.init = '1';

      var handle = btn.dataset.wishlistToggle;
      var saved = wishlist.indexOf(handle) !== -1;
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');

      btn.addEventListener('click', function () {
        var current = getWishlist();
        var idx = current.indexOf(handle);
        if (idx === -1) {
          current.push(handle);
        } else {
          current.splice(idx, 1);
        }
        saveWishlist(current);
        var isSaved = current.indexOf(handle) !== -1;
        document.querySelectorAll('[data-wishlist-toggle]').forEach(function (other) {
          if (other.dataset.wishlistToggle !== handle) return;
          other.classList.toggle('is-saved', isSaved);
          other.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
        });
        updateWishlistCount(current.length);
        var savedProducts = btn.closest('[data-wishlist-products]');
        var card = btn.closest('.product-card');
        if (!isSaved && savedProducts && card) {
          var neighbour = card.nextElementSibling || card.previousElementSibling;
          var empty = savedProducts.parentElement.querySelector('[data-wishlist-empty]');
          var focusTarget = neighbour && neighbour.querySelector('[data-wishlist-toggle]');
          card.remove();
          if (!savedProducts.children.length && empty) {
            var state = empty.querySelector('[data-wishlist-state]');
            if (state) state.textContent = 'No saved pieces yet. Tap the heart on a piece you love.';
            focusTarget = empty.querySelector('a');
          }
          if (focusTarget) focusTarget.focus();
        }
      });
    });
  }

  /* ─────────────────────────────────────────────
   * 9. Pincode checker stub
   * Form:    [data-pincode-form]
   * Input:   [data-pincode-input]
   * Success: [data-pincode-success]
   * Error:   [data-pincode-error]
   * ───────────────────────────────────────────── */
  function initPincodeChecker(root) {
    root.querySelectorAll('[data-pincode-form]').forEach(function (form) {
      if (form.dataset.init) return;
      form.dataset.init = '1';

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('[data-pincode-input]');
        var successEl = form.querySelector('[data-pincode-success]');
        var errorEl = form.querySelector('[data-pincode-error]');
        if (!input) return;

        var val = input.value.replace(/\D/g, '');
        if (val.length === 6) {
          if (errorEl) errorEl.hidden = true;
          if (successEl) successEl.hidden = false;
        } else {
          if (successEl) successEl.hidden = true;
          if (errorEl) errorEl.hidden = false;
        }
      });
    });
  }

  /* ─────────────────────────────────────────────
   * 10. Scroll reveal opt-out
   * If body[data-animations="false"], add class no-animations to body
   * ───────────────────────────────────────────── */
  function initScrollRevealOptOut() {
    if (document.body.dataset.animations === 'false') {
      document.body.classList.add('no-animations');
    }
  }

  /* ─────────────────────────────────────────────
   * initAll — run all modules against a root element
   * ───────────────────────────────────────────── */
  function initAll(root) {
    initLinkLabels(root);
    initAnnouncementBar(root);
    initHeaderCompaction(root);
    initMobileMenu(root);
    initFaq(root);
    initHeroCarousel(root);
    initQtySteppers(root);
    initEmailValidation(root);
    initWishlist(root);
    initPincodeChecker(root);
    initScrollRevealOptOut();
  }

  // Expose the initializer so cart.js can re-bind handlers (e.g. drawer qty
  // steppers) after it re-renders the cart drawer via the Section Rendering API.
  window.ThemeInit = initAll;

  /* ─────────────────────────────────────────────
   * Bootstrap
   * ───────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  // Theme Editor: re-initialize when a section is injected
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  // Theme Editor: clear timers when a section is removed/replaced
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-menu-open]').forEach(function(button){if(button._disposeMenu)button._disposeMenu();});
    var bar = e.target.querySelector('[data-announcement-bar]');
    if (bar && bar._disposeAnnouncement) bar._disposeAnnouncement();
    if (bar && bar._rotTimer) {
      clearInterval(bar._rotTimer);
      bar._rotTimer = null;
    }
    var carousel = e.target.querySelector('[data-hero-carousel]');
    if (carousel && carousel._disposeCarousel) carousel._disposeCarousel();
    if (carousel && carousel._autoTimer) {
      clearInterval(carousel._autoTimer);
      carousel._autoTimer = null;
    }
  });

})();
